<template>
  <div id="Categories">
    <div class="nav-sub">
      <h4>
        Categories
      </h4>
      <ul>
        <li v-for="(category, categoryIndex) in authorizedCategories" :key="categoryIndex">
          <router-link :to="'/catalog/catalogListing?currentCategoryId=' + category.Id" exact>
            {{ category.Title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { siteSectionsHelper }        from "@/components/mixins/siteSectionsHelper"
  import { brandAndRegionAuthHelper } from "@/components/mixins"
  export default {
    mixins: [siteSectionsHelper, brandAndRegionAuthHelper],
    props: {
      categories: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      authorizedCategories() {
        var authorizedCategories = this.categories.filter(x => 
          this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth)
        );
        return authorizedCategories;
      }
    },
  }
</script>
<style scoped>
#Categories {
  width: 100%;
}
</style>
